import DealByProductTile from './DealByProductTile';

export default DealByProductTile;
